import { render, staticRenderFns } from "./MrpaSubject.vue?vue&type=template&id=d464bce8&"
import script from "./MrpaSubject.vue?vue&type=script&lang=js&"
export * from "./MrpaSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports